import { render, staticRenderFns } from "./V2CartActions.vue?vue&type=template&id=4b98a458&scoped=true&"
import script from "./V2CartActions.vue?vue&type=script&lang=js&"
export * from "./V2CartActions.vue?vue&type=script&lang=js&"
import style0 from "./V2CartActions.vue?vue&type=style&index=0&id=4b98a458&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b98a458",
  null
  
)

export default component.exports